export const duplicatesCardInfo = {
	dueDate: "Vencimento",
	subtitle: "Duplicata",
	title: "Duplicatas",
	value: "Valor",
};
